import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RecoilRoot } from "recoil";
import { ThemeProvider } from "styled-components";
import { GlobalStyleProvider } from "./core/GlobalStyleProvider";
import { Routes } from "./core/Routes";
import { theme } from "./styles/theme";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import PreloadProvider from "./core/PreloadProvider";
import "devextreme/dist/css/dx.light.compact.css";
import "devexpress-gantt/dist/dx-gantt.min.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "@toast-ui/editor/dist/toastui-editor.css";
import "@toast-ui/editor/dist/theme/toastui-editor-dark.css";
import "@toast-ui/editor-plugin-table-merged-cell/dist/toastui-editor-plugin-table-merged-cell.css";
import TabContents from "./core/TabContents";
import { MainTemplate } from "./components/templates/MainTemplate";
import "react-datepicker/dist/react-datepicker.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  console.log("version 1.0.2");
  return (
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <PreloadProvider>
          <GlobalStyleProvider>
            <ThemeProvider theme={theme}>
              <Routes />
              <MainTemplate>
                <TabContents />
              </MainTemplate>
            </ThemeProvider>
          </GlobalStyleProvider>
        </PreloadProvider>
      </RecoilRoot>
    </QueryClientProvider>
  );
}

export default App;
